module.exports = __webpack_public_path__ + "static/bsas003.thumb-64365b62dba1453bf907e58df2528656.jpg";